exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".player-wrapper {\n  position: relative;\n  padding-top: 56.25%;\n}\n\n.react-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n}", ""]);

